// Format product description to display features as bullet points
document.addEventListener('DOMContentLoaded', function() {
  const productDescriptions = document.querySelectorAll('.product__description');
  
  productDescriptions.forEach(function(description) {
    let content = description.innerHTML;
    let featuresProcessed = false;
    
    // First check: Look for existing bullet lists (• or ul/li)
    const existingBulletList = description.querySelector('ul') || 
                             (content.includes('•') && !content.includes('Product Features:'));
    
    if (existingBulletList && !content.includes('Product Features:')) {
      // If we have a bullet list already but no heading
      if (description.querySelector('ul')) {
        // Insert heading before the first ul
        const firstUl = description.querySelector('ul');
        const heading = document.createElement('p');
        heading.innerHTML = '<strong>Product Features:</strong>';
        firstUl.parentNode.insertBefore(heading, firstUl);
        featuresProcessed = true;
      } 
      // If we have bullet points (•) but no actual list
      else if (content.includes('•')) {
        // Try to find a paragraph with bullet points
        const paragraphs = content.split('</p>');
        let bulletParagraphIndex = -1;
        
        // Find paragraph with bullet points
        for (let i = 0; i < paragraphs.length; i++) {
          if (paragraphs[i].includes('•')) {
            bulletParagraphIndex = i;
            break;
          }
        }
        
        if (bulletParagraphIndex !== -1) {
          // Insert heading before this paragraph
          const bulletParagraph = paragraphs[bulletParagraphIndex];
          paragraphs[bulletParagraphIndex] = `<p><strong>Product Features:</strong></p>${bulletParagraph}`;
          description.innerHTML = paragraphs.join('</p>');
          featuresProcessed = true;
        }
      }
    }
    
    // Special check for existing Product Features section
    if (!featuresProcessed && content.includes('Product Features:')) {
      featuresProcessed = true; // Already has the header, don't process further
    }
    
    // Special case: Look for "Features:" label
    if (!featuresProcessed && (content.includes('Features:') || content.includes('Features ') || content.includes('FEATURES:'))) {
      // Extract features section
      const featuresMatch = content.match(/(Features:?|FEATURES:?)(.*?)(<\/p>|<br>|$)/s);
      
      if (featuresMatch && featuresMatch[2]) {
        let featuresList = featuresMatch[2].trim();
        
        // Only use these separators for splitting if they appear at the beginning of a line or after a clear break
        const primarySeparators = ['•', '\\*'];
        
        // First try to find primary separators like bullets
        let usedSeparator = null;
        let mostMatches = 0;
        
        for (const separator of primarySeparators) {
          const regex = new RegExp(separator, 'g');
          const matches = (featuresList.match(regex) || []).length;
          
          if (matches > mostMatches && matches >= 2) {
            mostMatches = matches;
            usedSeparator = separator;
          }
        }
        
        // If no primary separators found with enough matches, try comma and pipe as fallbacks
        if (!usedSeparator || mostMatches < 2) {
          const secondarySeparators = ['\\|', ' - ', ','];
          
          for (const separator of secondarySeparators) {
            const regex = new RegExp(separator, 'g');
            const matches = (featuresList.match(regex) || []).length;
            
            if (matches > mostMatches && matches >= 2) {
              mostMatches = matches;
              usedSeparator = separator;
            }
          }
        }
        
        // Only use semicolon as a separator if there are clear newlines or spacing patterns
        if ((!usedSeparator || mostMatches < 2) && featuresList.includes(';')) {
          // Check if semicolons are likely to be separators (preceded by period or at specific pattern)
          const hasSemicolonSeparators = /\.\s*;/.test(featuresList) || /;\s*[A-Z]/.test(featuresList);
          
          if (hasSemicolonSeparators) {
            usedSeparator = ';';
            mostMatches = (featuresList.match(/;/g) || []).length;
          }
        }
        
        // If we found a reasonable separator with multiple matches
        if (usedSeparator && mostMatches > 0) {
          // Split by the separator and create list items
          const regex = new RegExp(usedSeparator, 'g');
          const features = featuresList.split(regex).filter(item => item.trim().length > 0);
          const listItems = features.map(feature => `<li>${feature.trim()}</li>`).join('');
          
          // Create the bullet list HTML with heading
          const bulletList = `<p><strong>Product Features:</strong></p><ul class="product-features-list">${listItems}</ul>`;
          
          // Replace the features section in the content
          content = content.replace(featuresMatch[0], bulletList);
          description.innerHTML = content;
          featuresProcessed = true;
        }
      }
    }
    
    // Proceed with the original approach for other formats only if we haven't processed features yet
    if (!featuresProcessed) {
      // Common feature separators to look for
      const separators = [' \\| ', '\\|', ' - ', ' • ', ' \\* ', '\\*'];
      
      // Find which separator is used in this description
      let usedSeparator = null;
      let bestParagraph = null;
      let bestSeparatorCount = 0;
      
      // Split into paragraphs to analyze
      const paragraphs = content.split('</p>');
      
      // Check each paragraph for potential features
      for (const paragraph of paragraphs) {
        if (!paragraph.includes('<p')) continue;
        
        // Extract text content
        const textMatch = paragraph.match(/<p[^>]*>(.*)/i);
        if (!textMatch) continue;
        
        const text = textMatch[1];
        
        // Skip very long paragraphs (likely not feature lists)
        if (text.length > 500) continue;
        
        // Check all separators
        for (const separator of separators) {
          const regex = new RegExp(separator, 'g');
          const matches = (text.match(regex) || []).length;
          
          // If this has more occurrences than our current best
          if (matches > bestSeparatorCount && matches >= 2) {
            bestSeparatorCount = matches;
            usedSeparator = separator;
            bestParagraph = paragraph;
          }
        }
        
        // Only use comma or semicolon as a last resort
        if (bestSeparatorCount < 2) {
          const lastResortSeparators = [',\\s', ';\\s*[A-Z]'];
          
          for (const separator of lastResortSeparators) {
            const regex = new RegExp(separator, 'g');
            const matches = (text.match(regex) || []).length;
            
            if (matches >= 2) {
              bestSeparatorCount = matches;
              usedSeparator = separator === ',\\s' ? ',' : ';';
              bestParagraph = paragraph;
            }
          }
        }
      }
      
      // If we found a good candidate paragraph with separators
      if (bestParagraph && usedSeparator) {
        const regex = new RegExp(usedSeparator, 'g');
        
        // Find and process the best paragraph
        const formattedParagraphs = paragraphs.map(paragraph => {
          if (paragraph === bestParagraph) {
            // Extract the paragraph text
            const match = paragraph.match(/<p[^>]*>(.*)/i);
            if (match) {
              const text = match[1];
              
              // Split by the separator and create list items
              const features = text.split(regex).filter(item => item.trim().length > 0);
              const listItems = features.map(feature => `<li>${feature.trim()}</li>`).join('');
              
              // Replace the paragraph with a heading and list
              return `<p><strong>Product Features:</strong></p><ul class="product-features-list">${listItems}</ul>`;
            }
          }
          
          // Return unchanged paragraph
          return paragraph + (paragraph.includes('</p>') ? '' : '</p>');
        });
        
        description.innerHTML = formattedParagraphs.join('');
      }
      // Last resort: If no structured features found, look for short bullet-like sentences
      else if (!featuresProcessed) {
        // Short sentences that might be features (4-70 chars)
        const shortSentenceRegex = /<p[^>]*>([^\.]{4,70}\.)[^<]*<\/p>/g;
        let shortSentences = [];
        let match;
        
        // Clone the content so we can safely modify it
        let contentCopy = content;
        
        // Find all short sentences that might be features
        while ((match = shortSentenceRegex.exec(content)) !== null) {
          shortSentences.push(match[1].trim());
        }
        
        // If we have at least 2 short sentences, treat them as features
        if (shortSentences.length >= 2) {
          const listItems = shortSentences.map(sentence => `<li>${sentence}</li>`).join('');
          const bulletList = `<p><strong>Product Features:</strong></p><ul class="product-features-list">${listItems}</ul>`;
          
          // Add at the end of the description
          description.innerHTML = content + bulletList;
          featuresProcessed = true;
        }
      }
    }
  });
}); 